var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"card-bg rounded-20",attrs:{"flat":""}},[_c('v-toolbar',{staticClass:"transparent",attrs:{"flat":"","dense":""}},[_c('v-toolbar-title',{staticClass:"title-font"},[_vm._v(" "+_vm._s(_vm.currentTenant.name.toUpperCase())+" USERS")])],1),_c('AuthorizedTenantUsers')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }